'use strict';
var PropTypes = require('prop-types');

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importDefault(require('react'));

var useThemeContext_1 = require('../../../hooks/useThemeContext');

var Icon_1 = __importDefault(require('../Icon'));

var HelpMonochrome = function HelpMonochrome(props) {
  var theme = useThemeContext_1.useThemeContext();
  var fill = props.fill;
  var color = fill || theme.themeConfig.baseColors.primary1(1) || '#7700FF';
  return react_1.default.createElement(
    Icon_1.default,
    __assign({}, props, {
      fill: color,
    }),
    react_1.default.createElement('circle', {
      opacity: '0.1',
      cx: '12',
      cy: '12',
      r: '10',
    }),
    react_1.default.createElement('path', {
      d: 'M10.9862 14.088H12.7502C12.7502 13.472 12.9042 13.108 13.4082 12.674C14.8082 11.47 15.2142 10.784 15.2142 9.66403C15.2142 8.08203 14.0102 7.00403 11.9802 7.00403C9.97818 7.00403 8.73218 8.43203 8.73218 9.83203C8.73218 10.252 8.80218 10.574 8.92818 10.84L10.5382 10.504C10.4822 10.364 10.4402 10.168 10.4402 9.98603C10.4402 9.11803 11.1682 8.60003 12.0222 8.60003C12.8762 8.60003 13.4782 9.06203 13.4782 9.79003C13.4782 10.504 13.1142 10.994 12.1902 11.736C11.2662 12.478 10.9862 13.01 10.9862 13.864V14.088ZM10.9442 17H12.7922V15.068H10.9442V17Z',
    })
  );
};

HelpMonochrome.propTypes = {
  /**
   * Задает цвет иконки
   */
  fill: PropTypes.string,
};

HelpMonochrome.displayName = 'HelpMonochrome';
exports.default = HelpMonochrome;
